import React from "react";

const ComponentLoader = () => {
  return (
    <div className="flex items-center justify-center h-full w-full py-10">
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="relative" style={{ width: 36, height: 36 }}>
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background: "radial-gradient(circle, rgb(var(--primary-rgb) / 6%) 0%, transparent 70%)",
              transform: "scale(2)",
            }}
          />
          <svg
            viewBox="0 0 36 36"
            fill="none"
            className="absolute inset-0"
            style={{ width: 36, height: 36, animation: "clRotate 1.4s cubic-bezier(0.4, 0, 0.2, 1) infinite" }}
          >
            <circle cx="18" cy="18" r="14" stroke="rgb(var(--primary-rgb) / 8%)" strokeWidth="2" fill="none" />
            <path
              d="M18 4a14 14 0 0 1 14 14"
              stroke="url(#clGrad)"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
            />
            <defs>
              <linearGradient id="clGrad" x1="18" y1="4" x2="32" y2="18">
                <stop offset="0%" stopColor="var(--primary-color)" stopOpacity="0.2" />
                <stop offset="100%" stopColor="var(--primary-color)" stopOpacity="1" />
              </linearGradient>
            </defs>
          </svg>
          <div
            className="absolute rounded-full"
            style={{
              width: 5,
              height: 5,
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "var(--primary-color)",
              animation: "clPulse 1.4s ease-in-out infinite",
            }}
          />
        </div>

        {/* Dots */}
        <div className="flex items-center gap-[4px] mt-4">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="rounded-full"
              style={{
                width: 3.5,
                height: 3.5,
                backgroundColor: "var(--primary-color)",
                animation: `clDot 1.2s ease-in-out ${i * 0.15}s infinite`,
              }}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes clRotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes clPulse {
          0%, 100% { opacity: 0.3; transform: translate(-50%, -50%) scale(0.8); }
          50% { opacity: 1; transform: translate(-50%, -50%) scale(1.2); }
        }
        @keyframes clDot {
          0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
          40% { opacity: 1; transform: scale(1.3); }
        }
      `}</style>
    </div>
  );
};

export default ComponentLoader;
